import { dailySessionNotes } from '../../actions/constant';

const {
  ARCHIVE_DAILY_SESSION_NOTE_SUCCESS,
  ARCHIVE_DAILY_SESSION_NOTE_FAILURE,
  ARCHIVE_DAILY_SESSION_NOTE_LOADING,
  ARCHIVE_DAILY_SESSION_NOTE_RESET,
} = dailySessionNotes;

/**
 * BOPS-151: REMOVE the archived row from the list.
 *
 * Archiving hard-deletes the note and its form submission, so the row is gone server-side the
 * moment the call returns. Marking it archived in place — what this did before — leaves a ghost
 * row that survives until the next fetch and then vanishes. The note's document lives on in the
 * Archived Documents section, which the hook refetches separately.
 */
export const removeArchived = (state: any, payload: any) => {
  const dsnUuid = payload?.dsnUuid;
  const content = state?.response?.content;
  if (!dsnUuid || !Array.isArray(content)) return state;
  return {
    ...state,
    response: {
      ...state.response,
      content: content.filter((document: any) => document?.dailySessionNoteUuid !== dsnUuid),
    },
  };
};

const initialState: object = {
  response: null,
  loading: false,
  isSuccess: false,
  isError: false,
};

export const archiveDailySessionNoteReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ARCHIVE_DAILY_SESSION_NOTE_SUCCESS: {
      return {
        ...state,
        response: action.payload?.response,
        loading: false,
        isSuccess: true,
        isError: false,
      };
    }

    //  Unlike the delete reducer this carries an explicit isError: the archive has two
    //  expected refusals (no billable codes, no saved PDF) whose message has to reach the
    //  dialog, and isSuccess: false alone cannot be told apart from "not attempted yet".
    case ARCHIVE_DAILY_SESSION_NOTE_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: false,
        isError: true,
      };

    case ARCHIVE_DAILY_SESSION_NOTE_LOADING:
      return {
        ...state,
        loading: true,
        isError: false,
      };

    case ARCHIVE_DAILY_SESSION_NOTE_RESET:
      return initialState;

    default:
      return state;
  }
};
